<h2 mat-dialog-title i18n="@@exit-dialog-title">Do you really want to leave the page?</h2>

<mat-dialog-content class="mat-dialog-content--exit">
    <p i18n="@@exit-dialog-description"
        >There are unsaved changes. These will be lost if you decide to leave the page.</p
    >
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-flat-button class="riege-button" i18n="@@button-label-cancel" (click)="handleConfirm(false)"
        >Cancel</button
    >
    <button
        mat-flat-button
        class="riege-button"
        color="primary"
        (click)="handleConfirm(true)"
        i18n="@@button-label-confirm"
        >Confirm</button
    >
</mat-dialog-actions>
